import React from "react";
import styled from "styled-components";
import { Card } from "react-bootstrap";
import { socialPlatforms } from "@components/NewBusinessBox/BusinessBoxHelpers";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px;
  background-color: #ffffff;
  border-radius: 5px;
  height: 25vh;
`;

const StyledCardImg = styled(Card.Img)`
  height: 60px;
  width: 60px;
  border-radius: 50%;
  object-fit: cover;
  align-self: center;
`;

const StyledCardTitle = styled(Card.Title)`
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  font-family: "DM Sans", sans-serif;
  text-align: center;
  color: #123051;
`;

const LinksContainer = styled.div`
  display: flex;
`;

const StyledLink = styled.a`
  margin-right: 10px;
`;

const StyledImage = styled.img`
  height: 20px;
  width: 20px;
`;

const StyledSpan = styled.span`
  font-size: 12px;
  line-height: 14.5px;
  font-weight: 400;
  font-family: "DM Sans", sans-serif;
  text-align: center;
  color: #123051;
`;

const StyledA = styled.a`
  font-size: 12px;
  line-height: 14.5px;
  font-weight: 400;
  font-family: "DM Sans", sans-serif;
  text-align: center;
  color: #0058b8;
  white-space: nowrap;
  overflow: hidden;
  textoverflow: ellipsis;
  display: block;
  cursor: pointer;
  text-decoration: none;
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

function Preview1({ businessBoxData }) {
  return (
    <Container>
      <StyledCardImg
        variant="top"
        src={businessBoxData?.business_image}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src =
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png";
        }}
      />
      <StyledCardTitle>{businessBoxData?.name || "N/A"}</StyledCardTitle>

      {businessBoxData?.business_link?.length > 0 && (
        <LinksContainer>
          {businessBoxData.business_link.map((linkItem) => {
            const platform = socialPlatforms.find(
              (platform) => platform.name === linkItem.platform
            );

            if (!platform) return null;

            return (
              <StyledLink
                key={linkItem.id}
                href={linkItem.link}
                target="_blank"
                rel="noreferrer"
              >
                <StyledImage
                  alt={linkItem.platform.toLowerCase()}
                  src={platform.icon}
                />
              </StyledLink>
            );
          })}
        </LinksContainer>
      )}

      {businessBoxData?.business_title && (
        <StyledSpan>{businessBoxData?.business_title}</StyledSpan>
      )}

      <InfoContainer>
        {businessBoxData?.business_email && (
          <StyledSpan style={{ color: "#0058B8" }}>
            {businessBoxData?.business_email}
          </StyledSpan>
        )}

        {businessBoxData?.business_url && (
          <StyledA
            href={businessBoxData?.business_url}
            target="blank"
            title={businessBoxData?.business_url}
          >
            {businessBoxData?.business_url}
          </StyledA>
        )}
      </InfoContainer>
    </Container>
  );
}

export default Preview1;
